<template>
<div id="protocol" >

	<!-- android隐私政策 -->
	<div class="bgdiv" v-if="status == 1" v-html="info.secret"></div>
	<!-- android用户协议 -->
	<div class="bgdiv" v-else-if="status == 2" v-html="info.userdesc"></div>
	 <!-- ios隐私政策 -->
	<div class="bgdiv" v-else-if="status == 3" v-html="info.iossecret"></div>
	<!-- ios用户协议 -->
	<div class="bgdiv" v-else v-html="info.iosuserdesc"></div>


</div>

</template>
<script>
import protocoldesc from '@/assets/js/protocoldesc.js'
export default{
	name:'protocol',
	data(){
		return {
			info:protocoldesc,
			status:1
		}
	},
	created(){
		this.status = this.$route.query.status || 1;
	}
}



</script>
<style lang='scss'>
#protocol{
	font-size:15px;
	width:100%;
	height:100%;
	position:absolute;
	overflow-y:auto;
	-webkit-overflow-scrolling: touch;
	.bgdiv{
		padding:10px;
	}
}
</style>
